import styled from 'styled-components';

export const WelcomeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
